import createUrlPattern from "./createUrlPattern"
import checkUrlAgainstPattern from "./checkUrlAgainstPattern"

interface Thread {
	// TODO
	_id: string
	x: number
	location: {
		host: string
		path: string
		selector: string
		percentFromLeft: number
	}
}

export default function positionCommentX(
	thread: Thread,
	type: "preview" | "thread",
) {
	// first check if this is the right page for a thread
	const { host, pathPatternArray } = createUrlPattern(
		window.location.host,
		window.location.pathname,
	)
	const correctPageToDisplayThreadOn = checkUrlAgainstPattern(
		{ host, pathPatternArray },
		{
			host: thread.location.host,
			pathPatternArray: JSON.parse(thread.location.path),
		},
	)

	// then find the element the comment was left on and put the comment in the right place for that selector

	const element = document.querySelector(thread.location.selector)

	// if no such element on the page, do not display the comment
	// and if comment is made on document.body, do not display the comment
	if (!element || !correctPageToDisplayThreadOn) {
		return -1000
	} else {
		const rect = element.getBoundingClientRect()

		let newX = rect.x + thread.location.percentFromLeft * rect.width

		// now make sure it doesn't go off the screen

		let coords: DOMRect

		if (type == "preview") {
			coords = (document.querySelector(
				`#jam--preview-thread-${thread._id}`,
			) as Element).getBoundingClientRect()
		} else if (type == "thread") {
			coords = document.querySelector(`#jam--thread-container-${thread._id}`)
				? (document.querySelector(
						`#jam--thread-container-${thread._id}`,
				  ) as Element).getBoundingClientRect()
				: (document.querySelector(
						`#jam--preview-thread-${thread._id}`,
				  ) as Element).getBoundingClientRect()
		} else {
			// TODO
			throw new Error("TODO")
		}

		if (window.innerWidth < thread.x + coords.width) {
			const amountToMoveLeft = thread.x + coords.width - window.innerWidth
			newX = thread.x - amountToMoveLeft - 5
		}

		if (newX < 5 || thread.x < 5) {
			newX = 5
		}

		// x is not < (coords.width/2) then move the comment over a bit
		if (newX > coords.width / 2) {
			newX = newX - coords.width / 2
		}

		return newX
	}
}
